var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic"},[_c('interface-navigation'),_c('transition-fade',[_c('router-view',{staticClass:"page-content h-content md:min-h-full",attrs:{"keep-alive":""}})],1),_c('interface-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }